"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getTableDataFor = exports.getObjectValues = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _shortid = _interopRequireDefault(require("shortid"));

var _togaCheckbox = _interopRequireDefault(require("@thinkific/toga-checkbox"));

var _togaInlineActions = _interopRequireDefault(require("@thinkific/toga-inline-actions"));

var _constants = require("../constants");

var _Datatable = _interopRequireDefault(require("../Datatable.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Datatable["default"]);

var getObjectValues = function getObjectValues(rowData, columnsToHide) {
  return Object.keys(rowData).filter(function (key) {
    return !columnsToHide.includes(key);
  }).map(function (key) {
    return rowData[key];
  });
};

exports.getObjectValues = getObjectValues;

var getTableDataFor = function getTableDataFor(rowData, columnsToHide) {
  if (Array.isArray(rowData)) {
    return rowData.filter(function (_, index) {
      return !columnsToHide.includes(index);
    });
  }

  return getObjectValues(rowData, columnsToHide);
};

exports.getTableDataFor = getTableDataFor;

var SimpleRow = function SimpleRow(_ref) {
  var columnsToHide = _ref.columnsToHide,
      rowData = _ref.rowData,
      selectedIds = _ref.selectedIds,
      handleToggle = _ref.handleToggle,
      rowActions = _ref.rowActions,
      hasFreezeActions = _ref.hasFreezeActions,
      tableWidth = _ref.tableWidth,
      rowItemId = _ref.rowItemId,
      isNotSelectable = _ref.isNotSelectable,
      isAllDatasetSelected = _ref.isAllDatasetSelected;

  var localHandleToogle = function localHandleToogle() {
    handleToggle(rowItemId);
  };

  var isRowSelected = isAllDatasetSelected || selectedIds.indexOf(rowItemId) >= 0;
  return /*#__PURE__*/_react["default"].createElement("tr", {
    className: cx({
      selected: isRowSelected
    })
  }, !isNotSelectable && /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('header-toolbar__checkbox--wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_togaCheckbox["default"], {
    isChecked: isRowSelected,
    onChange: localHandleToogle
  }))), getTableDataFor(rowData, columnsToHide).map(function (columnValue) {
    return /*#__PURE__*/_react["default"].createElement("td", {
      key: _shortid["default"].generate(),
      style: {
        textAlign: typeof columnValue === 'number' ? 'right' : 'left'
      }
    }, columnValue ? columnValue.toString() : '');
  }), rowActions && /*#__PURE__*/_react["default"].createElement("td", {
    className: cx({
      "static": hasFreezeActions,
      'freeze-right': hasFreezeActions,
      'frozen-column': hasFreezeActions,
      'frozen-column-compact': tableWidth < _constants.COMPACT_MODE_WIDTH
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('simple-row__wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_togaInlineActions["default"], {
    actions: rowActions,
    forceMainActionOpen: hasFreezeActions && tableWidth > _constants.COMPACT_MODE_WIDTH,
    icon: "ellipsis-v",
    isCompactMode: tableWidth < _constants.COMPACT_MODE_WIDTH
  }))), hasFreezeActions && /*#__PURE__*/_react["default"].createElement("td", null));
};

SimpleRow.propTypes = {
  columnsToHide: _propTypes["default"].array,
  handleToggle: _propTypes["default"].func,
  hasFreezeActions: _propTypes["default"].bool,
  isAllDatasetSelected: _propTypes["default"].bool.isRequired,
  isNotSelectable: _propTypes["default"].bool.isRequired,
  rowActions: _propTypes["default"].array,
  rowData: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  rowItemId: _propTypes["default"].string.isRequired,
  selectedIds: _propTypes["default"].array,
  tableWidth: _propTypes["default"].number
};
SimpleRow.defaultProps = {
  columnsToHide: [],
  hasFreezeActions: false,
  rowData: [],
  handleToggle: function handleToggle() {},
  selectedIds: [],
  rowActions: null,
  tableWidth: null
};
var _default = SimpleRow;
exports["default"] = _default;